<template>
  <div class="container mt-5">
    <router-link class="float-right" to="/groups">
      <i class="fas fa-chevron-left"></i> Regresar
    </router-link>

    <h1 class="text-light">
      <i class="fas fa-id-card mr-3"></i>
      {{group.group.name}}
    </h1>

    <b-table
      class="mt-3"
      striped
      :busy="isBusy"
      hover
      responsive
      :items="students"
      :fields="fields"
    >
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Obteniendo datos...</strong>
        </div>
      </template>

      <template v-slot:cell(picture)="data" class="text-right">
        <!-- <img :src="data.item.picture" alt="atchecker" :style="{width:'100px', height:'100px', transform:rotation}"> -->
        <div  :style="{width:'100px', height:'100px', transform:rotation, background: 'url(' + data.item.picture +')', backgroundSize:'contain', backgroundRepeat:'no-repeat'}"></div>
      </template>

      <template v-slot:cell(id)="data" class="text-right">
        <router-link
          :to="'/students/details/' + data.item.id"
          class="btn btn-dark ml-2"
          
          title="Detalles"
        >
          <i class="fas fa-info-circle"></i>
        </router-link>
        <router-link
          :to="'/students/edit/' + data.item.id"
          class="btn btn-dark ml-2"
          
          title="Modificar"
        >
          <i class="fas fa-edit"></i>
        </router-link>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      url: this.$store.state.url,
      group: {},
      students: [],
      isBusy: true,
      fields: [
        {class:"text-light", key: "code", label: "Código", sortable: false },
        {class:"text-light", key: "lastname", label: "Apellido", sortable: true },
        {class:"text-light", key: "name", label: "Nombre", sortable: false },
        {class:"text-light", key: "picture", label: "", sortable: false },
        {class:"text-light", key: "id", label: "", sortable: false },
      ],
      rotation: this.$store.state.rotation,
    };
  },
  mounted() {
    this.getData();
    this.getStudents();
  },
  methods: {
    async getData() {
      let req = await fetch(this.url + "group/" + this.id);      
      this.group = await req.json();
    },
    async getStudents() {
      let req = await fetch(this.url + "studentsByGroup/" + this.id);
      this.students = await req.json();
      this.isBusy = false;
    }
  }
};
</script>

<style>
</style>